export default "__VITE_ASSET__379e1ff7__"